import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CashFreeSlice{
    clientSecret:string | null;
    transactionRefId:string | null;
    orderDetail: any | null;
}

const initialState:CashFreeSlice ={
    clientSecret:null,
    transactionRefId:null,
    orderDetail: null
}

export const cashFreeSlice = createSlice({
    name:'cashFree',
    initialState,
    reducers:{
        setCashFreePaymentDetail:(
            state,
            action:PayloadAction<{
                clientSecret:string | null;
                transactionRefId:string | null;
                orderDetail: {} | null;
            }>
        )=>{
            state.clientSecret= action.payload?.clientSecret;
            state.transactionRefId = action.payload?.transactionRefId
            state.orderDetail = action.payload;
        },
        resetPaymentDetail:(state)=>{
            state.clientSecret = null;
            state.transactionRefId= null;
            state.orderDetail = {};
            state =initialState;
        }
    }
})

export const {setCashFreePaymentDetail, resetPaymentDetail} = cashFreeSlice.actions;
export const getClientSecret = (state: any) => state.cashFree?.clientSecret;
export const getTransactionRefId = (state: any) => state.cashFree?.transactionRefId;
export const getOrderDetails = (state: any) => state.cashFree?.orderDetail;


export default cashFreeSlice.reducer;